export default {"src":"/_next/static/media/united-states.58956a94.svg","height":394,"width":622};